import { empApi } from "./client";

// Tạo phiếu giới thiệu nhân viên
export const createEmployeeRequestApi = (body) => empApi.post("/employee/app", body);

// Danh mục lựa chọn
const list = (url) => empApi.get(url, { page: 1, limit: 999 });
export const getBranchListApi = () => list("/branch");
export const getSaleAreaListApi = () => list("/saleArea");
export const getSaleBlockListApi = () => list("/saleBlock");
export const getJobTitleListApi = () => list("/jobTitle");
// Chức vụ của màn giới thiệu việc làm: BE lọc sẵn theo ngữ cảnh + khối bộ phận
// (0 = Hỗ trợ kinh doanh, 1 = Kinh doanh)
export const getJobPositionListApi = (department) =>
  empApi.get("/jobPosition", {
    page: 1,
    limit: 999,
    scope: "REGISTER_EMPLOYEE",
    ...(department === undefined ? {} : { department }),
  });
export const getBusinessCategoryListApi = () => list("/businessCategory");
export const getSupportDepartmentListApi = () => list("/supportDepartment");
